/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventNewsletterController', DinghyEventNewsletterController);

    DinghyEventNewsletterController.$inject = ['entity', '$http', 'Principal'];

    function DinghyEventNewsletterController(entity, $http, Principal) {
        var vm = this;
        vm.dinghyEvent = entity;
        vm.contactMail = vm.dinghyEvent.contactEmailResolved;
        vm.action = action;
        vm.sendMail = {startId: 0, projectID: entity.id};
        vm.dinghyEventType = vm.dinghyEvent.type;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        function action(action) {
            vm.sendMail.action = action;
            vm.isSaving = true;
            $http.post('api/board/dinghy-events/mail/', vm.sendMail).then(function() {
                vm.isSaving = false;
            });
        }
    }
})();
